const URL_RE = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

export function Linkify({ text }) {
  return text.split(URL_RE).map((part, i) => {
    if (!part.match(URL_RE)) return part;
    const clean = part.replace(/[.,;:!?)]+$/, "");
    const tail = part.slice(clean.length);
    const href = clean.startsWith("http") ? clean : `https://${clean}`;
    return (
      <span key={i}>
        <a href={href} target="_blank" rel="noopener noreferrer" className="underline font-semibold text-[#1f5f42] hover:text-[#2e7d56] break-all" data-testid="linkified-url">{clean}</a>{tail}
      </span>
    );
  });
}
